export const statusIcon= {
  'Reconciliation':'reconciliation.svg',
  'Notification sent':'notification_sent.svg',
  'Notification Sent':'notification_sent.svg',
  'Sent':'notification_sent.svg',
  'Delivered':'notification_sent.svg',
  'Sending':'notification_sent.svg',
  'Delivery Failures':'reconciliation_failures.svg',
  'Delivery failures':'reconciliation_failures.svg',
  'Completed':'closed.svg',
  'Complete':'closed.svg',
  'Create notification':'create_notification.svg',
  'Notification Created':'create_notification.svg',
  'Draft': 'draft_notification.svg',
  'Superseded': 'notification_sent.svg',
  'Cancelled': 'notification_sent.svg',
}

export const recepientTableColumns = [
  { key: 'Name', value: 'CustomerContactName' },
  { key: 'Email', value: 'CustomerContactEmail' },
  { key: 'Date Sent', value: 'DateSent' },
  { key: 'Date Delivered', value: 'DateDelivered' },
  { key: 'Date Read', value: 'DateRead' },
  { key: 'Reminder sent', value: 'ReminderSent' },
  { key: 'Reminder planned', value: 'ReminderPlanned' },
  { key: 'Feedback Received', value: 'FeedbackReceived' },
  { key: 'Resend Date', value: 'ResendDate' },
  { key: 'Status', value: 'Status' },
  { key: 'Date Delivery Failed', value: 'DateDeliveryFailed' }
];

export const recepientTableInit = [
  { key: 'Name', value: 'CustomerContactName' },
  { key: 'Email', value: 'CustomerContactEmail' },
  { key: 'Date Sent', value: 'DateSent' },
  { key: 'Date Delivered', value: 'DateDelivered' },
  { key: 'Date Read', value: 'DateRead' },
  { key: 'Feedback Received', value: 'FeedbackReceived' },
  { key: 'Status', value: 'Status' }
];

export const accountTableInit = [
  { key: 'ID', value: 'AccountId' },
  { key: 'Name', value: 'AccountName' },
  { key: 'Date Sent', value: 'AccountDateSent' },
  { key: 'Date Delivered', value: 'AccountDateDelivered' },
  { key: 'Date Read', value: 'AccountDateRead' },
  { key: 'Feedback Received', value: 'AccountFeedbackReceived' },
  { key: 'Status', value: 'AccountStatus' },
  { key: 'Delivery Failures', value: 'AccountDeliveryFailures' }
];

export const accountTableColumns = [
  { key: 'ID', value: 'AccountId' },
  { key: 'Name', value: 'AccountName' },
  { key: 'Date Sent', value: 'AccountDateSent' },
  { key: 'Date Delivered', value: 'AccountDateDelivered' },
  { key: 'Date Read', value: 'AccountDateRead' },
  { key: 'Feedback Received', value: 'AccountFeedbackReceived' },
  { key: 'Status', value: 'AccountStatus' },
  { key: 'Delivery Failures', value: 'AccountDeliveryFailures' }
];